import { render, staticRenderFns } from "./SidenavSettings.vue?vue&type=template&id=6ac2a231"
import script from "./SidenavSettings.vue?vue&type=script&lang=js"
export * from "./SidenavSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports